import axios from 'axios'
import { api } from '@/services'

export function list(params) {
  return api.get('admin/divergence', { params })
}

/** Delta exato do recálculo. Não persiste nada. */
export function simulate(payload) {
  return api.post('admin/divergence/simulate', payload)
}

export function approve(payload) {
  return api.post('admin/divergence/approve', payload)
}

/**
 * Aprovação do ressarcimento de viagem. Endpoint próprio porque não há recálculo: registra a
 * decisão e o lançamento do valor é feito à parte pelo time.
 */
export function approveReimbursement(payload) {
  return api.post('admin/divergence/approveReimbursement', payload)
}

export function refuse(payload) {
  return api.post('admin/divergence/refuse', payload)
}

export function contest(payload) {
  return api.post('admin/divergence/contest', payload)
}

export function reverse(payload) {
  return api.post('admin/divergence/reverse', payload)
}

/**
 * Checkin do host, lido direto do checklist — o hauseful não guarda cópia da coordenada. Mesmo
 * token: o auth server é compartilhado e o hcheck é resource server, como no entitlement.
 *
 * Axios próprio em vez do `checklistApi`, pelo mesmo motivo do `entitlementApi`: aquele módulo
 * captura o token no import, que fica velho na primeira leitura logo depois do login.
 */
export function checkIn(appointmentId) {
  const baseURL = process.env.VUE_APP_CHECKLIST_API_URL
  const token = localStorage.getItem('access_token')

  if (!baseURL || !token) return Promise.reject(new Error('Checklist lookup not configured'))

  return axios.get(`${baseURL}/admin/job/checkIn/${appointmentId}`, {
    headers: { Authorization: `Bearer ${token}` },
    timeout: 10000,
  })
}

/** URL assinada da evidência. Expira, então é buscada a cada abertura do card. */
export function fileDownloadURL(divergenceId, fileId) {
  return api.get(`admin/divergence/${divergenceId}/file/${fileId}`)
}
